import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Login from "./auth/login";
import Mapa from "./Mapa";
import AdminCTO from "./admin/AdminCTO";
import Cadastro from "./auth/cadastro";
import ProtectedRoute from "./auth/ProtectedRoute";
import Usuarios from "./admin/Usuarios";
import { useState, useEffect } from "react";
import { api } from "./api";

export default function App() {
  const [role, setRole] = useState(null);
  const [loadingRole, setLoadingRole] = useState(true);

  useEffect(() => {
    const savedRole = localStorage.getItem("role");
    const savedToken = localStorage.getItem("token");

    if (savedRole && savedToken) {
      api.defaults.headers.Authorization = `Bearer ${savedToken}`;
      setRole(savedRole);
    }

    setLoadingRole(false);
  }, []);

  if (loadingRole) return <div>Carregando...</div>;

  const handleLogin = (roleFromBackend, token) => {
    localStorage.setItem("role", roleFromBackend);
    localStorage.setItem("token", token);
    api.defaults.headers.Authorization = `Bearer ${token}`;
    setRole(roleFromBackend);
  };

  const handleLogout = () => {
    localStorage.clear();
    setRole(null);
  };

  // Redireciona para a rota correta conforme o role
  const homeRoute = () => {
    if (role === "admin") return "/admin";
    if (role === "viewer") return "/admin";
    if (role === "tech") return "/mapa";
    return "/login";
  };

  return (
    <BrowserRouter>
      <Routes>
        {/* LOGIN */}
        <Route path="/login" element={<Login onLogin={handleLogin} />} />

        {/* MAPA PARA TECH e ADMIN */}
        <Route
          path="/mapa"
          element={
            <ProtectedRoute role={role} allowed={["admin", "tech"]}>
              <Mapa onLogout={handleLogout} />
            </ProtectedRoute>
          }
        />

        {/* ADMIN + VIEWER — viewer entra aqui em modo leitura */}
        <Route
          path="/admin"
          element={
            <ProtectedRoute role={role} allowed={["admin", "viewer"]}>
              <AdminCTO role={role} onLogout={handleLogout} />
            </ProtectedRoute>
          }
        />

        {/* CADASTRO: ADMIN ONLY */}
        <Route
          path="/cadastro"
          element={
            <ProtectedRoute role={role} allowed={["admin"]}>
              <Cadastro />
            </ProtectedRoute>
          }
        />
        
        <Route
          path="/usuarios"
          element={
            <ProtectedRoute role={role} allowed={["admin"]}>
              <Usuarios onLogout={handleLogout} />
            </ProtectedRoute>
          }
        />

        {/* FALLBACK — redireciona para home correta conforme role */}
        <Route
          path="*"
          element={<Navigate to={homeRoute()} replace />}
        />
      </Routes>
    </BrowserRouter>
  );
}